import React from "react";
import ImgixFluidImage from "./ImgixFluidImage";
import { useDisclosure } from "@chakra-ui/react";
import { ModalComponent } from "./modalComponent";

const CardPopUp = ({image, standalone=false, readMoreLabel="Read more", title, subtitle, href, color, modalTitle, hasFocalPoint=true, sizes = "(min-width: 500px) 350px, 560px", ar, placeHolderImage, className, children, ...other}) => {

  const { isOpen, onOpen, onClose } = useDisclosure();

  const finalImage = image ? <ImgixFluidImage attribution={image.attribution} image={image} sizes={sizes} ar={ar||16/9} focalPoint={image.focalPoint} />  : placeHolderImage;

  const colors = ["", "box--red", "box--orange"];

  // some cards aren't in 3s. Ths class removes flex 33%
  const standaloneClass = standalone ? "standalone" : "";

  return (
    
      <button className={`box ${standaloneClass} box--secondary ${colors[color]} swiper-slide ${className} focus:outline-none text-left`} {...other} onClick={onOpen}>

        <div className="box__inner">
          {/* box__image  */}
          <figure className="image-fit js-image-fit h-[250px]">{finalImage}</figure>
          <div className="box__body">
            <p className="box__title h6">{title}</p>
            <div dangerouslySetInnerHTML={{ __html: subtitle }} className="truncate-overflow box__subtitle"></div>
            <div className="box__link link-more text-gray-3">{readMoreLabel}</div>
          </div>
        </div>
        <ModalComponent isOpen={isOpen} onClose={onClose} title={modalTitle}>{children}</ModalComponent>
      </button>
  );
};

export default CardPopUp;
